<template>
  <div class="mobile-breadcrumb">
    <span>当前位置：</span>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/'}">
       首页
      </el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item,itemIndex) in currentNav" :key="itemIndex" :to="{path: item.path || ''}">
         {{ item.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { wordLimit } from '@/filter'

export default {
  name: 'MobileBreadcrumb',
  props: ['title'],
  computed: {
    currentNav () {
      const menuList = {
        news: '新闻公告',
        edu: '双创教育',
        space: '创业空间'
      }
      const typeObj = JSON.parse(window.localStorage.getItem('typeObj'))
      const {
        type,
        typeCode,
        name,
        searchStr,
        id
      } = this.$route.query
      let groupType = ''
      if (!type) {
        for (const obj in typeObj) {
          for (const item of typeObj[obj]) {
            if (item.dictLabel === name) {
              groupType = item.dictType
            }
          }
        }
      }
      if (type) {
        return [
          {
            name: name,
            path: `/newsList?type=${type}&name=${name}`
          }
        ]
      }

      if (searchStr) {
        return [
          {
            name: '搜索',
            path: `/newsList?searchStr=${searchStr}`
          }
        ]
      }
      if (typeCode) {
        return [
          {
            name: menuList[groupType],
            path: `/newsList?type=${groupType}&name=${menuList[groupType]}`
          },
          {
            name: name,
            path: `/newsList?typeCode=${typeCode}&name=${name}`
          }
        ]
      }
      if (id && this.title) {
        return [
          {
            name: wordLimit(this.title, 10),
            path: `/newsDetail?id=${id}`
          }
        ]
      }
      return []
    }
  }
}
</script>

<style scoped lang="scss">
.mobile-breadcrumb {
  display: flex;
  margin: 0.625rem;
  font-size: 0.875rem;
  align-items: center;
  color: #333;
}
</style>
